module.exports = __webpack_public_path__ + "static/screenshot-summarytable-410356406e9a69000e1c122367d0d399.png";